import { Button, DatePicker, Form, Input, Row, Spin, message } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  getMasterEvent,
  getMasterEventDetails,
  updateMasterEvent,
} from '../../api/event.api'
import UpdateEventDetail from '../../components/event/UpdateEventDetail'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/sales.module.scss'

const EventSnsEditPage = () => {
  const [eventAttendances, setEventAttendances] = useState({
    content: [],
    pageable: { pageNumber: 0, pageSize: 10 },
    totalElements: 0,
  })
  const [isLoading, setIsLoading] = useState(false)
  const params = useParams()
  const [masterInfo, setMasterInfo] = useState(null)
  const [detailInfo, setDetailInfo] = useState([])
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [editingKey, setEditingKey] = useState('')
  const [detailForm] = Form.useForm()
  const [adding, setAdding] = useState(false)

  const getMasterEventInfo = async () => {
    try {
      setIsLoading(true)
      const res = await getMasterEvent(params?.eventId)
      setMasterInfo(res.data)
      form.setFieldsValue({
        title: res.data.title,
        description: res.data.description,
        startDateTime: dayjs(res.data.startDateTime),
        endDateTime: dayjs(res.data.endDateTime),
      })
    } catch (error) {
      console.error(error)
      setMasterInfo(null)
      return null
    } finally {
      setIsLoading(false)
    }
  }
  const getEventDetails = async () => {
    try {
      const res = await getMasterEventDetails(params?.eventId)
      setDetailInfo(res.data)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getMasterEventInfo()
    getEventDetails()
    // eslint-disable-next-line
  }, [])

  const handleSaveMaster = async (e) => {
    e.preventDefault()
    Swal.fire({
      title: '정말 수정하시겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        saveMasterInfo(e)
      }
    })
  }

  const saveMasterInfo = async (e) => {
    e.preventDefault()

    const values = await form.validateFields()
    const param = {
      ...values,
      id: Number(params?.eventId),
      eventType: masterInfo.eventType,
      startDateTime: values.startDateTime
        ? dayjs(values.startDateTime).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      endDateTime: values.endDateTime
        ? dayjs(values.endDateTime).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }
    try {
      const res = await updateMasterEvent(param)
      if (res.status === 200) {
        message.success('수정되었습니다.')
      }
    } catch (error) {
      console.error(error)
    }
  }

  // 추가 폼 제출
  const onAddDetail = async (values) => {
    // 실제 저장 API 호출 필요
    const newId = Math.max(0, ...detailInfo.map((d) => d.id)) + 1
    setDetailInfo([
      ...detailInfo,
      {
        ...values,
        id: newId,
        active: values.active === 'true',
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
      },
    ])
    detailForm.resetFields()
    setAdding(false)
    message.success('추가되었습니다.')
  }

  // 인라인 편집용 컬럼 (항상 input/셀렉트 노출, onChange로 상태 반영)
  const handleDetailChange = (id, key, value) => {
    setDetailInfo((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, [key]: key === 'active' ? value === 'true' : value }
          : item,
      ),
    )
  }

  if (isLoading) {
    return <Spin />
  }

  return (
    <>
      <ContentHeader title="[혜택] SNS 이벤트 수정" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/* 상태 필터 드롭박스 */}
        <div
          style={{
            margin: '16px 0',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        ></div>
        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{
            marginTop: 20,
            borderBottom: 0,
            justifyContent: 'space-between',
          }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            SNS 이벤트 수정
          </span>
          <Button
            type="primary"
            style={{ color: 'white' }}
            className={`${styles['product-register-box-title']}`}
            onClick={(e) => {
              e.stopPropagation()
              handleSaveMaster(e)
            }}
            htmlType="button"
          >
            수정
          </Button>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <h3>이벤트 전체 정보</h3>
          <Form
            form={form}
            layout="vertical"
            style={{ maxWidth: '50%', marginTop: 20 }}
          >
            <Form.Item
              label="이벤트 제목"
              name="title"
              rules={[{ required: true, message: '제목을 입력하세요.' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="이벤트 설명"
              name="description"
              rules={[{ required: false, message: '설명을 입력하세요.' }]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>

            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Form.Item
                label="시작일시"
                name="startDateTime"
                rules={[{ required: false, message: '시작일시를 선택하세요.' }]}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: '100%' }}
                  allowClear={false}
                />
              </Form.Item>
              <span style={{ margin: '0 10px' }}>~</span>
              <Form.Item
                label="종료일시"
                name="endDateTime"
                rules={[{ required: false, message: '종료일시를 선택하세요.' }]}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: '100%' }}
                  allowClear={false}
                />
              </Form.Item>
            </Row>
          </Form>
          {/* 상세 수정 */}
          <UpdateEventDetail
            detailInfo={detailInfo}
            setDetailInfo={setDetailInfo}
            detailForm={detailForm}
            onAddDetail={onAddDetail}
            handleDetailChange={handleDetailChange}
            styles={styles}
            getEventDetails={getEventDetails}
          />
        </div>
      </div>
    </>
  )
}

export default EventSnsEditPage
